module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page",
    staticStyle: {
      "visibility": "hidden"
    },
    attrs: {
      "data-loaded": "false",
      "id": _vm.pageContainerId,
      "data-page-number": "pageNumber"
    },
    on: {
      "mousedown": _vm.mouseDown,
      "mouseup": _vm.mouseUp,
      "contextmenu": function($event) {
        _vm.preventContext($event)
      }
    }
  }, [_c('div', {
    staticClass: "canvasWrapper"
  }, [_c('canvas', {
    attrs: {
      "id": ("page" + _vm.pageNumber),
      "height": _vm.pageHeight,
      "width": _vm.pageWidth
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textLayer"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64a6e070","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./sample/components/project/pdf-page.vue
// module id = 657
// module chunks = 2